<template>
  <HScaffold title="账户与安全">
    <template #customRight>
      <div @click="useComApi.openService"
           style="display: flex;flex-direction: row;align-items: center;justify-content: center">
        <img :src="iconService" style="height:25px;" alt="">
        <div :style="hcf.getTextStyle({color:'main',marginLeft:3})">客服</div>
      </div>
    </template>
    <div class="tSafeParentDiv">
      <div :style='{
        backgroundImage:`url(${iconBg})`,
        backgroundRepeat: "no-repeat",
        height:"210px",
        backgroundSize: "100% 100%",
        backgroundPosition: "left",
        display:"flex",
        alignItems:"center",
    }'>
        <img :src="iconBgBottom" style="width:80%" alt="">
        <div
            style="position: absolute;right:13%;display:flex;flex-direction: column;align-items: center;justify-content: center;">
          <div :style="hcf.getTextStyle({
              color:'main',addSize:2,
            })">完善个人账户信息更安全
          </div>
          <div :style="hcf.getTextStyle({
              color:'main',addSize:16,fontWeight:'bold',
            })">账户安全中心
          </div>
          <div :style='{
        backgroundImage:`url(${iconAlertBg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
        backgroundPosition: "top",
        display:"flex",
        alignItems:"center",
        padding:"3px 10px",
    }'>
            <div :style="hcf.getTextStyle({
                color:'#8A604B'
            })">检测到{{useUser.checkCanOptimizationCount()}}个可优化项
            </div>
          </div>
        </div>
      </div>
      <div @click="item.callback" v-for="item in allCheckInfos" :key="item.title"
           style="padding:10px;display: flex;background-color: white;margin:0 10px 10px 10px;border-radius:8px;flex-direction: row;align-items: center;">
        <img :src="item.icon" style="height:40px;" alt="">
        <div style="margin-left:10px;display: flex;flex-direction: column;flex:1;">
          <div :style="hcf.getTextStyle({
                addSize:1,
            })">{{item.title}}</div>
          <div :style="hcf.getTextStyle({
                color:item.isOk?'#888':'#ff0000cc',addSize:-2
            })">{{item.desc}}</div>
        </div>
        <div style="display:flex;align-items: center;justify-content: center;">
          <img :src="item.isOk?iconOk:iconWarning" style="height:23px" alt="">
          <van-icon name="arrow" />
        </div>
      </div>
      <HServicePrase/>
    </div>
  </HScaffold>

</template>


<script setup>
  import HScaffold from "@/components/utils/HScaffold.vue";
  import {hcf} from "@/components/utils/HComFunctions.js";
  import {useHComApi} from "@/hooks/useHComApi.js";

  import iconBg from "@/assets/icons/safe/bg.png";
  import iconAlertBg from "@/assets/icons/safe/alert_bg.png";
  import iconBgBottom from "@/assets/icons/safe/bg_bottom.png";
  import iconBindCard from "@/assets/icons/safe/bind_card.png";
  import iconBindPhone from "@/assets/icons/safe/bind_phone.png";
  import iconTradePwd from "@/assets/icons/safe/trade_pwd.png";
  import iconLoginPwd from "@/assets/icons/safe/login_pwd.png";
  import iconOk from "@/assets/icons/safe/state_ok.png";
  import iconWarning from "@/assets/icons/safe/state_warning.png";
  import {useUserStore} from "@/stores/useUser.js";
  import HServicePrase from "@/components/utils/HServicePrase.vue";
  import {showToast} from "vant";
  import {hr} from "@/components/utils/HRouter.js";


  const iconService = hcf.getNewGameUIIcon("service.png");
  let useComApi = useHComApi();
  let useUser = useUserStore();



  const getIsBindCard = computed(()=>{
    let isHaveBindCard = false;
    for(let eachKey  in useUser.withdrawMap.keys){
      if(useUser.withdrawMap[eachKey].length>0){
        isHaveBindCard = true;
        break;
      }
    }
    return isHaveBindCard;
  })

  let allCheckInfos = ref([
    {
      icon:iconBindPhone,
      title:"绑定手机号码",
      desc:"绑定后账户异常能及时通知",
      isOk:useUser.phoneNumber !== "",
      callback:()=>{
        hr.go("bind-phone");
      }
    },
    {
      icon:iconBindCard,
      title:"绑定提现方式",
      desc:"可绑定或管理提现方式",
      isOk:getIsBindCard,
      callback:()=>{
        hr.go("bind_card");
      }
    },
    {
      icon:iconTradePwd,
      title:"交易密码管理",
      desc:"设置交易密码,保障资金安全",
      isOk:useUser.isHaveSafePwd,
      callback:()=>{
        if (!useUser.isHaveSafePwd) {
          hr.go("set-trade-pwd");
        } else {
          showToast("如需更改，请联系《人工客服》");
        }
      }
    },
    {
      icon:iconLoginPwd,
      title:"登录密码管理",
      desc:"定期修改登录密码,有利账户安全",
      isOk:useUser.isHavePwd,
      callback:()=>{
        hr.go("set-login-pwd");
      }
    },
  ]);

</script>


<style scoped>

  .tSafeParentDiv {
    display: flex;
    flex-direction: column;
  }

</style>
